import script from "./UploadContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadContainer.vue?vue&type=script&setup=true&lang=js"

import "./UploadContainer.vue?vue&type=style&index=0&id=654e9074&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-654e9074"]])

export default __exports__